// extracted by mini-css-extract-plugin
export default {"customLikeWrapper":"ecsWx","customLike":"wdFsN"};